(() => {
  const styleId = 'gruendl-shopify-forms-textarea-label-fix';
  const selector = 'form [class*="formFieldContainer"]:has(textarea)::before';
  const css = `${selector} { height: calc(var(--form-field-padding-top) + 0.25rem) !important; }`;
  const observedRoots = new WeakSet();

  function applyFix(root) {
    if (!root.querySelector('form textarea') || root.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = css;
    root.append(style);
  }

  function inspectElement(element) {
    if (element.shadowRoot) inspectShadowRoot(element.shadowRoot);

    element.querySelectorAll?.('*').forEach((child) => {
      if (child.shadowRoot) inspectShadowRoot(child.shadowRoot);
    });
  }

  function inspectShadowRoot(root) {
    applyFix(root);

    if (observedRoots.has(root)) return;
    observedRoots.add(root);

    new MutationObserver(() => {
      applyFix(root);
      root.querySelectorAll('*').forEach((element) => {
        if (element.shadowRoot) inspectShadowRoot(element.shadowRoot);
      });
    }).observe(root, { childList: true, subtree: true });

    root.querySelectorAll('*').forEach((element) => {
      if (element.shadowRoot) inspectShadowRoot(element.shadowRoot);
    });
  }

  function inspectDocument() {
    inspectElement(document.documentElement);
  }

  function init() {
    inspectDocument();

    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) inspectElement(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
